export default "__VITE_ASSET__D8ivwytk__"